import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
    name: 'moneyPipe'
  })
  export class MoneyPipe implements PipeTransform {
    amount: any;
  
    transform(value: any, args?: any): any {
        let result = value;
        if (typeof value !== 'undefined' && value !== null) {
          const pos = value
            .toString()
            .trim()
            .indexOf('.');
          let front = value.toString().trim();
          let back = '';
          if (pos > 0) {
            front = value.toString().substring(0, pos);
            back =
              value
                .toString()
                .substring(pos + 1)
                .replace(/\D/g, '') + '00';
            back = back.toString().substring(0, 2);
          }
          if (isNaN(parseFloat(result.toString().trim()))) {
            return result;
          }
          // Convert number to comma separated number string
          result = front.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',');
          if (back.length > 0) {
            result = result + '.' + back;
          }
        }
        return result;
      }
  }
  